import { _ as _typeof } from './typeof-5c86a240.esm.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from './asyncToGenerator-9cc1acb2.esm.js';
import { _ as _objectSpread2 } from './objectSpread2-04e3d2b4.esm.js';
import { _ as _createForOfIteratorHelper } from './createForOfIteratorHelper-27ce1999.esm.js';
import { a as _createClass, _ as _classCallCheck } from './createClass-38c45ab6.esm.js';
import { _ as _defineProperty } from './defineProperty-6a97efcd.esm.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import fetch from 'cross-fetch';

var LP_DOMAINS = ['livepeer', 'livepeercdn', 'lp-playback'];
var PLAYLIST_NAME = 'index.m3u8';
var ASSET_URL_PART_VALUE = 'hls';
var RECORDING_URL_PART_VALUE = 'recordings';

// Example url the playback id needs to be found in
// https://livepeercdn.com/hls/<playback-id>/index.m3u8
// https://livepeercdn.com/recordings/<playback-id>/index.m3u8
var getMetricsReportingUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(src) {
    var _parts, _splitHost, _splitHost2, parsedUrl, parts, playlistPartIndex, includesAssetUrl, includesRecording, playbackId, splitHost, includesDomain, tld, tldMapped, _response$url, response, redirectedUrl;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            parsedUrl = new URL(src);
            parts = parsedUrl.pathname.split('/');
            playlistPartIndex = parts.indexOf(PLAYLIST_NAME);
            includesAssetUrl = parts.includes(ASSET_URL_PART_VALUE);
            includesRecording = parts.includes(RECORDING_URL_PART_VALUE); // Check if the url is valid
            playbackId = (includesAssetUrl || includesRecording) && playlistPartIndex !== -1 ? (_parts = parts === null || parts === void 0 ? void 0 : parts[playlistPartIndex - 1]) !== null && _parts !== void 0 ? _parts : null : null;
            splitHost = parsedUrl.host.split('.');
            includesDomain = LP_DOMAINS.includes((_splitHost = splitHost === null || splitHost === void 0 ? void 0 : splitHost[splitHost.length - 2]) !== null && _splitHost !== void 0 ? _splitHost : '');
            tld = (_splitHost2 = splitHost === null || splitHost === void 0 ? void 0 : splitHost[(splitHost === null || splitHost === void 0 ? void 0 : splitHost.length) - 1]) !== null && _splitHost2 !== void 0 ? _splitHost2 : null; // map to known TLDs, with .com => .studio
            tldMapped = tld === 'com' ? 'studio' : tld === 'studio' ? 'studio' : tld === 'fun' ? 'fun:20443' : tld === 'monster' ? 'monster:10443' : null; // if not a known TLD, then do not return a URL
            if (!(playbackId && includesDomain && tldMapped)) {
              _context.next = 23;
              break;
            }
            _context.prev = 12;
            _context.next = 15;
            return fetch("https://playback.livepeer.".concat(tldMapped, "/json_video+").concat(playbackId, ".js"));
          case 15:
            response = _context.sent;
            // parse the url which we're redirected to
            redirectedUrl = response === null || response === void 0 ? void 0 : (_response$url = response.url) === null || _response$url === void 0 ? void 0 : _response$url.replace('https:', 'wss:');
            return _context.abrupt("return", redirectedUrl !== null && redirectedUrl !== void 0 ? redirectedUrl : null);
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](12);
            console.log("Could not fetch metrics reporting URL.", _context.t0);
          case 23:
            _context.next = 28;
            break;
          case 25:
            _context.prev = 25;
            _context.t1 = _context["catch"](0);
            return _context.abrupt("return", null);
          case 28:
            return _context.abrupt("return", null);
          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 25], [12, 20]]);
  }));
  return function getMetricsReportingUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();

var PlaybackMonitor = /*#__PURE__*/function () {
  function PlaybackMonitor(element) {
    _classCallCheck(this, PlaybackMonitor);
    _defineProperty(this, "active", false);
    _defineProperty(this, "values", []);
    _defineProperty(this, "score", null);
    _defineProperty(this, "averagingSteps", 20);
    _defineProperty(this, "element", void 0);
    this.element = element;
  }
  _createClass(PlaybackMonitor, [{
    key: "init",
    value: function init() {
      if (!this.active) {
        this.values = [];
        this.score = null;
        this.active = true;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!this.active) {
        // it's not running, start it up
        this.init();
      } else {
        this.values = [];
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.active) {
        this.values = [];
        this.score = null;
        this.active = false;
      }
    }
  }, {
    key: "calculateScore",
    value: function calculateScore() {
      if (this.active) {
        // save the current testing value and time
        // If the media plays, this should keep a constant value. If the media is stalled, it will go up with 1sec/sec. If the media is playing faster, it will go down.
        // current clock time - current playback time
        var latestPlaybackRecord = this.values.length > 0 ? this.values[this.values.length - 1] : undefined;
        var currentValue = {
          clockTime: Date.now() * 1e-3,
          mediaTime: this.element.currentTime,
          score: latestPlaybackRecord ? this.valueToScore(latestPlaybackRecord) : 0
        };
        this.values.push(currentValue); // add the current value to the history

        // no history yet, can't calculate a score
        if (this.values.length < 2) {
          return null;
        }
        var oldestValue = this.values[0];
        if (oldestValue !== undefined) {
          // diff between oldest score and current
          var averagedScore = this.valueToScore(oldestValue, currentValue); // should be 1, decreases if bad

          // kick the oldest value from the array
          if (this.values.length > this.averagingSteps) {
            this.values.shift();
          }

          // the final score is the maximum of the averaged and the current value
          this.score = Math.max(averagedScore, currentValue.score);
          return Math.round(this.score * 10) / 10;
        }
      }
      return null;
    }
  }, {
    key: "valueToScore",
    value: function valueToScore(a, b) {
      var _this$element, _b$mediaTime, _b$clockTime;
      // calculate the moving average
      // if this returns > 1, the media played faster than the clock
      // if this returns < 0, the media time went backwards
      var rate = this !== null && this !== void 0 && (_this$element = this.element) !== null && _this$element !== void 0 && _this$element.playbackRate ? this.element.playbackRate : 1;
      return ((_b$mediaTime = b === null || b === void 0 ? void 0 : b.mediaTime) !== null && _b$mediaTime !== void 0 ? _b$mediaTime : this.element.currentTime - a.mediaTime) / ((_b$clockTime = b === null || b === void 0 ? void 0 : b.clockTime) !== null && _b$clockTime !== void 0 ? _b$clockTime : Date.now() * 1e-3 - a.clockTime) / rate;
    }
  }]);
  return PlaybackMonitor;
}();
var MetricsStatus = /*#__PURE__*/function () {
  function MetricsStatus(element) {
    var _this = this;
    _classCallCheck(this, MetricsStatus);
    _defineProperty(this, "retryCount", 0);
    _defineProperty(this, "connected", false);
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "currentMetrics", void 0);
    _defineProperty(this, "previousMetrics", null);
    _defineProperty(this, "timeWaiting", 0);
    _defineProperty(this, "waitingSince", 0);
    _defineProperty(this, "timeStalled", 0);
    _defineProperty(this, "stalledSince", 0);
    _defineProperty(this, "timeUnpaused", 0);
    _defineProperty(this, "unpausedSince", 0);
    this.element = element;
    this.currentMetrics = {
      firstPlayback: 0,
      nWaiting: 0,
      timeWaiting: 0,
      nStalled: 0,
      timeStalled: 0,
      timeUnpaused: 0,
      nError: 0,
      videoHeight: null,
      videoWidth: null,
      playerHeight: null,
      playerWidth: null,
      player: 'generic',
      pageUrl: '',
      sourceUrl: '',
      playbackScore: null,
      duration: null
    };
    element.addEventListener('waiting', function () {
      _this.timeWaiting = _this._getTimeWaiting(); // in case we get waiting several times in a row
      _this.waitingSince = Date.now();
    });
    element.addEventListener('stalled', function () {
      _this.timeStalled = _this._getTimeStalled(); // in case we get stalled several times in a row
      _this.stalledSince = Date.now();
    });
    var _iterator = _createForOfIteratorHelper(['playing', 'pause']),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var event = _step.value;
        element.addEventListener(event, function () {
          _this.timeWaiting = _this._getTimeWaiting();
          _this.timeStalled = _this._getTimeStalled();
          _this.waitingSince = 0;
          _this.stalledSince = 0;
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    element.addEventListener('playing', function () {
      _this.timeUnpaused = _this._getTimeUnpaused(); // in case we get playing several times in a row
      _this.unpausedSince = Date.now();
    });
    element.addEventListener('pause', function () {
      _this.timeUnpaused = _this._getTimeUnpaused();
      _this.unpausedSince = 0;
    });
  }
  _createClass(MetricsStatus, [{
    key: "_getTimeWaiting",
    value: function _getTimeWaiting() {
      return this.timeWaiting + (this.waitingSince ? Date.now() - this.waitingSince : 0);
    }
  }, {
    key: "_getTimeStalled",
    value: function _getTimeStalled() {
      return this.timeStalled + (this.stalledSince ? Date.now() - this.stalledSince : 0);
    }
  }, {
    key: "_getTimeUnpaused",
    value: function _getTimeUnpaused() {
      return this.timeUnpaused + (this.unpausedSince ? Date.now() - this.unpausedSince : 0);
    }
  }, {
    key: "addError",
    value: function addError(error) {
      this.currentMetrics.nError++;
      this.currentMetrics.lastError = error;
    }
  }, {
    key: "incrementStalled",
    value: function incrementStalled() {
      this.currentMetrics.nStalled++;
    }
  }, {
    key: "incrementWaiting",
    value: function incrementWaiting() {
      this.currentMetrics.nWaiting++;
    }
  }, {
    key: "getFirstPlayback",
    value: function getFirstPlayback() {
      return this.currentMetrics.firstPlayback;
    }
  }, {
    key: "setFirstPlayback",
    value: function setFirstPlayback() {
      this.currentMetrics.firstPlayback = Date.now() - bootMs;
    }
  }, {
    key: "setPlaybackScore",
    value: function setPlaybackScore(playbackScore) {
      this.currentMetrics.playbackScore = playbackScore;
    }
  }, {
    key: "setConnected",
    value: function setConnected(isConnected) {
      this.connected = isConnected;
    }
  }, {
    key: "getMetrics",
    value: function getMetrics() {
      var _this$element2, _this$element3, _this$element4, _this$element5;
      var currentMetrics = _objectSpread2(_objectSpread2({}, this.currentMetrics), {}, {
        playerHeight: this.element ? this.element.clientHeight : null,
        playerWidth: this.element ? this.element.clientWidth : null,
        videoWidth: (_this$element2 = this.element) !== null && _this$element2 !== void 0 && _this$element2.videoWidth ? (_this$element3 = this.element) === null || _this$element3 === void 0 ? void 0 : _this$element3.videoWidth : null,
        videoHeight: (_this$element4 = this.element) !== null && _this$element4 !== void 0 && _this$element4.videoHeight ? (_this$element5 = this.element) === null || _this$element5 === void 0 ? void 0 : _this$element5.videoHeight : null,
        duration: this.element.duration,
        timeWaiting: this._getTimeWaiting(),
        timeStalled: this._getTimeStalled(),
        timeUnpaused: this._getTimeUnpaused()
      });
      var previousMetrics = this.previousMetrics;
      this.previousMetrics = currentMetrics;
      return {
        current: currentMetrics,
        previous: previousMetrics
      };
    }
  }]);
  return MetricsStatus;
}();
var bootMs = Date.now(); // used for firstPlayback value
var VIDEO_METRICS_INITIALIZED_ATTRIBUTE = 'data-metrics-initialized';
/**
 * Gather playback metrics from a generic HTML5 video/audio element and
 * report them to a websocket. Automatically handles a redirect to get the
 * metrics endpoint.
 *
 * @param element Element to capture playback metrics from
 */
function addMediaMetrics(element, sourceUrl, onError) {
  var defaultResponse = {
    metrics: null,
    destroy: function destroy() {
      //
    }
  };
  if (!element || !sourceUrl) {
    return defaultResponse;
  }

  // do not attach twice (to the same websocket)
  if (element.hasAttribute(VIDEO_METRICS_INITIALIZED_ATTRIBUTE)) {
    return defaultResponse;
  }
  element.setAttribute(VIDEO_METRICS_INITIALIZED_ATTRIBUTE, 'true');
  if (!window.WebSocket) {
    console.log('Browser does not support WebSocket');
    return defaultResponse;
  }
  if (!('play' in element) || !('currentTime' in element)) {
    console.log('Element provided is not a media element');
    return defaultResponse;
  }
  var metricsStatus = new MetricsStatus(element);
  try {
    var _ret = function () {
      var createNewWebSocket = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var numRetries,
            reportingWebsocketUrl,
            newWebSocket,
            _args = arguments;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  numRetries = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
                  _context.next = 3;
                  return getMetricsReportingUrl(sourceUrl);
                case 3:
                  reportingWebsocketUrl = _context.sent;
                  if (!reportingWebsocketUrl) {
                    _context.next = 9;
                    break;
                  }
                  newWebSocket = new WebSocket(reportingWebsocketUrl);
                  newWebSocket.addEventListener('open', function () {
                    // enable active statistics reporting
                    report();
                  });
                  newWebSocket.addEventListener('close', function (event) {
                    // disable active statistics gathering
                    if (timeOut) {
                      clearTimeout(timeOut);
                      timeOut = null;
                      enabled = false;
                    }

                    // use random code for internal error
                    if (event.code !== 3077) {
                      // auto-reconnect with exponential backoff
                      setTimeout(function () {
                        createNewWebSocket(numRetries++).then(function (websocket) {
                          ws = websocket;
                        });
                      }, Math.pow(2, numRetries) * 1e3);
                    }
                  });
                  return _context.abrupt("return", newWebSocket);
                case 9:
                  return _context.abrupt("return", null);
                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function createNewWebSocket() {
          return _ref.apply(this, arguments);
        };
      }();
      var ws;
      createNewWebSocket().then(function (websocket) {
        ws = websocket;
      }).catch(function (e) {
        console.error(e);
        onError === null || onError === void 0 ? void 0 : onError(e);
      });
      var timeOut = null;
      var enabled = true;

      /////////////////////
      //  basics         //
      /////////////////////

      var firstPlay = function firstPlay() {
        metricsStatus.setFirstPlayback();
        element.removeEventListener('playing', firstPlay);
      };
      element.addEventListener('playing', firstPlay);
      element.addEventListener('waiting', function () {
        metricsStatus.incrementWaiting();
      });
      element.addEventListener('stalled', function () {
        metricsStatus.incrementStalled();
      });
      element.addEventListener('error', function () {
        var _element$error;
        metricsStatus.addError(element !== null && element !== void 0 && (_element$error = element.error) !== null && _element$error !== void 0 && _element$error.message ? element.error.message : 'unknown');
      });

      /////////////////////
      //  playbackScore  //
      /////////////////////

      var monitor = new PlaybackMonitor(element);

      // enable
      var _iterator2 = _createForOfIteratorHelper(['loadstart', 'play', 'playing']),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var eventName = _step2.value;
          element.addEventListener(eventName, function () {
            monitor.init();
          });
        }

        // disable
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(['loadeddata', 'pause', 'abort', 'emptied', 'ended']),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _eventName = _step3.value;
          element.addEventListener(_eventName, function () {
            monitor.destroy();
          });
        }

        // reset
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var _iterator4 = _createForOfIteratorHelper(['seeking', 'seeked', /*"canplay","playing",*/
        'ratechange']),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _eventName2 = _step4.value;
          element.addEventListener(_eventName2, function () {
            monitor.reset();
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var report = function report() {
        if (!enabled || !ws) {
          return;
        }

        // update playback score from monitor
        var playbackScore = monitor.calculateScore();
        if (playbackScore !== null) {
          metricsStatus.setPlaybackScore(playbackScore);
        }
        var metrics = metricsStatus.getMetrics();

        // only send a report if stats have changed, and only send those changes
        var d = {};
        var key;
        for (key in metrics.current) {
          var _metrics$previous;
          var val = metrics.current[key];
          if (val !== (metrics === null || metrics === void 0 ? void 0 : (_metrics$previous = metrics.previous) === null || _metrics$previous === void 0 ? void 0 : _metrics$previous[key])) {
            d[key] = val;
          }
        }
        if (Object.keys(d).length > 0) {
          send(ws, d);
        }
        timeOut = setTimeout(function () {
          report();
        }, 1e3);
      };
      var destroy = function destroy() {
        var _ws;
        enabled = false;
        monitor.destroy();
        if (timeOut) {
          clearTimeout(timeOut);
        }
        (_ws = ws) === null || _ws === void 0 ? void 0 : _ws.close(3077);
        element.removeAttribute(VIDEO_METRICS_INITIALIZED_ATTRIBUTE);
      };
      return {
        v: {
          metrics: metricsStatus,
          destroy: destroy
        }
      };
    }();
    if (_typeof(_ret) === "object") return _ret.v;
  } catch (e) {
    console.log(e);
  }
  return defaultResponse;
}
function send(webSocket, metrics) {
  if (webSocket.readyState !== webSocket.OPEN) {
    return;
  }
  webSocket.send(JSON.stringify(metrics));
}

var getMimeType = function getMimeType(ending) {
  for (var _i = 0, _arr = Object.keys(mime); _i < _arr.length; _i++) {
    var _mime$value;
    var value = _arr[_i];
    if ((_mime$value = mime[value]) !== null && _mime$value !== void 0 && _mime$value.some(function (v) {
      return v === ending;
    })) {
      return value;
    }
  }
  return null;
};
var mime = {
  'application/mp4': ['mp4s', 'm4p'],
  'application/ogg': ['ogx'],
  'application/vnd.apple.mpegurl': ['m3u8'],
  'audio/3gpp': ['*3gpp'],
  'audio/adpcm': ['adp'],
  'audio/amr': ['amr'],
  'audio/basic': ['au', 'snd'],
  'audio/midi': ['mid', 'midi', 'kar', 'rmi'],
  'audio/mobile-xmf': ['mxmf'],
  'audio/mp3': ['*mp3'],
  'audio/mp4': ['m4a', 'mp4a'],
  'audio/mpeg': ['mpga', 'mp2', 'mp2a', 'mp3', 'm2a', 'm3a'],
  'audio/ogg': ['oga', 'ogg', 'spx', 'opus'],
  'audio/s3m': ['s3m'],
  'audio/silk': ['sil'],
  'audio/vnd.dece.audio': ['uva', 'uvva'],
  'audio/vnd.digital-winds': ['eol'],
  'audio/vnd.dra': ['dra'],
  'audio/vnd.dts.hd': ['dtshd'],
  'audio/vnd.dts': ['dts'],
  'audio/vnd.lucent.voice': ['lvp'],
  'audio/vnd.ms-playready.media.pya': ['pya'],
  'audio/vnd.nuera.ecelp4800': ['ecelp4800'],
  'audio/vnd.nuera.ecelp7470': ['ecelp7470'],
  'audio/vnd.nuera.ecelp9600': ['ecelp9600'],
  'audio/vnd.rip': ['rip'],
  'audio/wav': ['wav'],
  'audio/wave': ['*wav'],
  'audio/webm': ['weba'],
  'audio/x-aac': ['aac'],
  'audio/x-aiff': ['aif', 'aiff', 'aifc'],
  'audio/x-caf': ['caf'],
  'audio/x-flac': ['flac'],
  'audio/x-m4a': ['*m4a'],
  'audio/x-matroska': ['mka'],
  'audio/x-mpegurl': ['m3u'],
  'audio/x-ms-wax': ['wax'],
  'audio/x-ms-wma': ['wma'],
  'audio/x-pn-realaudio-plugin': ['rmp'],
  'audio/x-pn-realaudio': ['ram', 'ra'],
  'audio/x-realaudio': ['*ra'],
  'audio/x-wav': ['*wav'],
  'audio/xm': ['xm'],
  'video/3gpp': ['3gp', '3gpp'],
  'video/3gpp2': ['3g2'],
  'video/h261': ['h261'],
  'video/h263': ['h263'],
  'video/h264': ['h264'],
  'video/iso.segment': ['m4s'],
  'video/jpeg': ['jpgv'],
  'video/jpm': ['*jpm', 'jpgm'],
  'video/mj2': ['mj2', 'mjp2'],
  'video/mp2t': ['ts'],
  'video/mp4': ['mp4', 'mp4v', 'mpg4'],
  'video/mpeg': ['mpeg', 'mpg', 'mpe', 'm1v', 'm2v'],
  'video/ogg': ['ogv'],
  'video/quicktime': ['qt', 'mov'],
  'video/vnd.dece.hd': ['uvh', 'uvvh'],
  'video/vnd.dece.mobile': ['uvm', 'uvvm'],
  'video/vnd.dece.pd': ['uvp', 'uvvp'],
  'video/vnd.dece.sd': ['uvs', 'uvvs'],
  'video/vnd.dece.video': ['uvv', 'uvvv'],
  'video/vnd.dvb.file': ['dvb'],
  'video/vnd.fvt': ['fvt'],
  'video/vnd.mpegurl': ['mxu', 'm4u'],
  'video/vnd.ms-playready.media.pyv': ['pyv'],
  'video/vnd.uvvu.mp4': ['uvu', 'uvvu'],
  'video/vnd.vivo': ['viv'],
  'video/webm': ['webm'],
  'video/x-f4v': ['f4v'],
  'video/x-fli': ['fli'],
  'video/x-flv': ['flv'],
  'video/x-m4v': ['m4v'],
  'video/x-matroska': ['mkv', 'mk3d', 'mks'],
  'video/x-mng': ['mng'],
  'video/x-ms-asf': ['asf', 'asx'],
  'video/x-ms-vob': ['vob'],
  'video/x-ms-wm': ['wm'],
  'video/x-ms-wmv': ['wmv'],
  'video/x-ms-wmx': ['wmx'],
  'video/x-ms-wvx': ['wvx'],
  'video/x-msvideo': ['avi'],
  'video/x-sgi-movie': ['movie'],
  'video/x-smv': ['smv']
};

var audioExtensions = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var videoExtensions = /\.(mp4|ogv|webm|mov|m4v|avi|m3u8)($|\?)/i;
var hlsExtensions = /\.(m3u8)($|\?)/i;
var getMediaSourceType = function getMediaSourceType(src) {
  var _hlsExtensions$exec$, _hlsExtensions$exec, _videoExtensions$exec, _videoExtensions$exec2, _audioExtensions$exec, _audioExtensions$exec2;
  return hlsExtensions.test(src) ? {
    type: 'hls',
    src: src,
    mime: getMimeType((_hlsExtensions$exec$ = (_hlsExtensions$exec = hlsExtensions.exec(src)) === null || _hlsExtensions$exec === void 0 ? void 0 : _hlsExtensions$exec[1]) !== null && _hlsExtensions$exec$ !== void 0 ? _hlsExtensions$exec$ : '')
  } : videoExtensions.test(src) ? {
    type: 'video',
    src: src,
    mime: getMimeType((_videoExtensions$exec = (_videoExtensions$exec2 = videoExtensions.exec(src)) === null || _videoExtensions$exec2 === void 0 ? void 0 : _videoExtensions$exec2[1]) !== null && _videoExtensions$exec !== void 0 ? _videoExtensions$exec : '')
  } : audioExtensions.test(src) ? {
    type: 'audio',
    src: src,
    mime: getMimeType((_audioExtensions$exec = (_audioExtensions$exec2 = audioExtensions.exec(src)) === null || _audioExtensions$exec2 === void 0 ? void 0 : _audioExtensions$exec2[1]) !== null && _audioExtensions$exec !== void 0 ? _audioExtensions$exec : '')
  } : null;
};

// Taken from video.js
// const _hlsTypes = new Set([
//   // Apple sanctioned
//   'application/vnd.apple.mpegurl',
//   // Apple sanctioned for backwards compatibility
//   'audio/mpegurl',
//   // Very common
//   'audio/x-mpegurl',
//   // Very common
//   'application/x-mpegurl',
//   // Included for completeness
//   'video/x-mpegurl',
//   'video/mpegurl',
//   'application/mpegurl',
// ]);

export { MetricsStatus as M, PlaybackMonitor as P, addMediaMetrics as a, getMediaSourceType as g };
